export default __webpack_public_path__ + "static/media/success.65ed4c6b.png";